<div
  [attr.data-cy]="dataCy ?? 'select-box-container'"
  id="search-container"
  class="select-box-container cm-dropdown {{ 'density-' + density }}"
  [ngClass]="{
    'dx-selectboxDefault': useDefaultStyle,
    'cm-select-box-form-field': isFormField,
    'cm-select-box-outlined': isFormField,
    'cm-select-box-form-field-disabled': disabled,
    'cm-form-field-readonly': readonly
  }"
>
  <dx-select-box
    data-cy="cm-select-box-search"
    class="typography__input-text"
    [dropDownOptions]="dropDownOptions"
    [wrapItemText]="true"
    [inputAttr]="{ title: selectedDisplayText }"
    #targetSelectBox
    [dataSource]="dataSource"
    [searchExpr]="searchExpr"
    [searchEnabled]="searchEnabled"
    [placeholder]="placeholder"
    [searchMode]="searchMode"
    [displayExpr]="displayExpr"
    [valueExpr]="valueExpr"
    [value]="value"
    [label]="label"
    labelMode="floating"
    [stylingMode]="isFormField ? 'outlined' : 'filled'"
    searchTimeout="{{ searchTimeout }}"
    minSearchLength="{{ minSearchLength }}"
    showDataBeforeSearch="{{ showDataBeforeSearch }}"
    showClearButton="{{ showClearButton }}"
    searchEnabled="searchEnabled"
    [acceptCustomValue]="true"
    (onSelectionChanged)="
      selectionChanged.emit($event);
      setSelectBoxIcon($event, iconExpr)
    "
    (onValueChanged)="valueChanged($event)"
    (onKeyUp)="keyDown($event)"
    (keyDown)="keyDown($event)"
    (onFocusOut)="focusOut($event)"
    (onInput)="input($event)"
    (onFocusIn)="focusIn()"
    [noDataText]="emptyMessage"
    (onCustomItemCreating)="createCustomItem($event)"
    itemTemplate="item"
    [disabled]="disabled"
    [readOnly]="readonly"
    [isValid]="!hasError"
  >
    <div
      *dxTemplate="let data of 'item'"
      class="cm-select-box-item typography__menu-item"
      [attr.data-cy]="'search-result-' + getDisplayValue(data)"
      [ngClass]="{ 'cm-select-box-no-badge': hideBadge, 'cm-select-box-item-icon': !!iconExpr }"
      [innerHtml]="
        (!!iconExpr ? listItemIcon(data, iconExpr) : '')+
        (highlight
          ? getDisplayValue(data, targetSelectBox.text)
          : getDisplayValue(data)
        )
      "
    ></div>
  </dx-select-box>
  <div class="cm-dropdown__progress-bar-container">
    <mat-progress-bar mode="indeterminate" class="cm-dropdown__progress-bar" *ngIf="isLoading"></mat-progress-bar>
  </div>
  <div class="cm-input-field__helper-area">
    <div
      class="cm-dropdown__error-message position-absolute"
      [class.top-location]="errorLocation === 'top'"
      *ngIf="hasError && errors?.required"
    >
      <mat-error class="cm-error-message"> {{ placeholder }} {{ 'form.isRequired' | translate }}. </mat-error>
    </div>
    <div class="cm-dropdown__error-message" *ngIf="hasError && errors?.duplicatedSupplier">
      <mat-hint class="cm-error-message"  data-cy="dropdown-duplicate-error"> {{ 'form.duplicate-supplier' | translate }}. </mat-hint>
    </div>
    <div class="cm-dropdown__error-message" *ngIf="errors?.requiredCostCenterValue">
      <mat-hint class="cm-error-message">
        {{ 'crib.cost-center-value' | translate }} {{ 'form.isRequired' | translate }}.
      </mat-hint>
    </div>
  </div>
</div>
